import './CopyA.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';

export interface CopyAContentType {
  color?: string;
  content?: string;
  mainComponent?: boolean;
  textAlign?: string;
}

interface CopyAProps extends CopyAContentType {}

export const CopyA = ({ color, content, mainComponent, textAlign }: CopyAProps) => {
  const _textAlign: b2x.TextAlign =
    textAlign === 'start' ? 'start' : textAlign === 'center' ? 'center' : textAlign === 'end' ? 'end' : 'start';
  return (
    <b2x.Div className="copy-a">
      <Container>
        <b2x.Div
          className="ff-helvetica-neue"
          paddingBottom={{ md: 4, xs: 3 }}
          style={{ color: color ?? undefined }}
          textAlign={_textAlign}
        >
          <b2x.ConditionalWrapper
            condition={content !== undefined}
            wrapper={
              mainComponent ? (
                <b2x.H1 className="content" fontWeight={700} margin={0} />
              ) : (
                <b2x.P className="content" fontWeight={700} margin={0} />
              )
            }
          >
            {b2x.formatHtml(content)}
          </b2x.ConditionalWrapper>
        </b2x.Div>
      </Container>
    </b2x.Div>
  );
};
